import { TemplatePage } from './types';

const independenceDayPage: TemplatePage = {
  header: {
    color: '#A3D1E0',
    icon: 'images/video-templates/independance-day.jpg',
    title: 'Independence Day Video Templates Collection',
    title_meta: '20+ Editable and Free Independence Day Video Templates',
    description_meta:
      'Fuel your 4th of July marketing campaigns with Wave.video’s customizable Independence Day video templates.',
    description:
      'Fuel your 4th of July marketing campaigns with customizable Independence Day video templates. Win over ' +
      'consumers and boost your conversions by making American pride-inspired videos that your audience will appreciate.'
  },
  footer: {
    category: 'Independence Day',
    description:
      'Wave.video’s variety of Independence Day video templates comes in handy for creating attention-grabbing ' +
      'marketing videos for your website, social media, blog, or email newsletter. All the templates are free and ' +
      'easy to customize to meet your brand’s goals.'
  },
  content: [
    {
      type: 'templates',
      title: 'Independence Day Videos',
      search: {
        category: '/Holidays & Occasions/Independence Day'
      }
    },
    {
      type: 'stocks',
      title: 'Independence Day',
      search: {
        name: 'Independence day'
      }
    },
    { type: 'calendar' }
  ]
};

export default independenceDayPage;
